'use client'

import React, { useState, useContext, createContext, useEffect } from 'react'
import useLocalStorage from '../hooks/useLocalStorage'

import auth0 from 'auth0-js';

export const UserMetaContext = createContext({})

const TOKEN_KEY = 'userMeta'
const TOKEN_INITIAL_VALUE = null

const UserMetaProvider = ({ children }) => {
  const [ userMeta, setUserMeta ] = useLocalStorage(
    TOKEN_KEY,
    TOKEN_INITIAL_VALUE
  )
  const [ webAuthClient, setWebAuthClient ] = useState<auth0.WebAuth | null>(null);

  useEffect(() => {
    try {
      const webAuth = new auth0.WebAuth({
        domain: process.env.NEXT_PUBLIC_AUTH0_DOMAIN,
        clientID: process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID
      });

      setWebAuthClient(webAuth);
    } catch (error) {
      console.error(error);
    }
  }, [])

  const handleSetUserMeta = (userMeta) => {
    setUserMeta(JSON.stringify(userMeta))
  }

  const handleGetUserMeta = () => {
    // console.log('handleGetUserMeta')
    return JSON.parse(userMeta)
  }

  const deleteUserMeta = () => {
    setUserMeta(null)
  }

  return (
    <UserMetaContext.Provider
      value={{
        handleGetUserMeta,
        handleSetUserMeta,
        deleteUserMeta,
        userMeta,
        webAuthClient
      }}
    >
      {children}
    </UserMetaContext.Provider>
  )
}

export default UserMetaProvider

export const useUserMeta = () => useContext(UserMetaContext)